// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IMinRolloverAmountPropertyDto
 */
export interface IMinRolloverAmountPropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IMinRolloverAmountPropertyDto
     */
    min_rollover_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IMinRolloverAmountPropertyDto
     */
    min_rollover_amount_type?: IMinRolloverAmountPropertyDtoMinRolloverAmountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IMinRolloverAmountPropertyDto
     */
    min_rollover_amount_type_state?: IMinRolloverAmountPropertyDtoMinRolloverAmountTypeStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IMinRolloverAmountPropertyDtoMinRolloverAmountTypeEnum {
    NO_MINIMUM = 'NO_MINIMUM',
    CUSTOM = 'CUSTOM'
}
/**
* @export
* @enum {string}
*/
export enum IMinRolloverAmountPropertyDtoMinRolloverAmountTypeStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IMinRolloverAmountPropertyDto interface.
 */
export function instanceOfIMinRolloverAmountPropertyDto(value: object): value is IMinRolloverAmountPropertyDto {
    return true;
}

export function IMinRolloverAmountPropertyDtoFromJSON(json: any): IMinRolloverAmountPropertyDto {
    return IMinRolloverAmountPropertyDtoFromJSONTyped(json, false);
}

export function IMinRolloverAmountPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IMinRolloverAmountPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'min_rollover_amount': json['min_rollover_amount'] == null ? undefined : json['min_rollover_amount'],
        'min_rollover_amount_type': json['min_rollover_amount_type'] == null ? undefined : json['min_rollover_amount_type'],
        'min_rollover_amount_type_state': json['min_rollover_amount_type_state'] == null ? undefined : json['min_rollover_amount_type_state'],
    };
}

export function IMinRolloverAmountPropertyDtoToJSON(json: any): IMinRolloverAmountPropertyDto {
    return IMinRolloverAmountPropertyDtoToJSONTyped(json, false);
}

export function IMinRolloverAmountPropertyDtoToJSONTyped(value?: IMinRolloverAmountPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'min_rollover_amount': value['min_rollover_amount'],
        'min_rollover_amount_type': value['min_rollover_amount_type'],
        'min_rollover_amount_type_state': value['min_rollover_amount_type_state'],
    };
}

